import { Injectable, isDevMode, NgZone } from '@angular/core';
import { Guard } from 'src/core-lib/misselaineous/guards';
import { Cookie } from 'src/utils/cookies';
import { ContentCacheUtils } from 'src/utils/storage.util';
import { GA4 } from '../models/ga4.model';
import { TagManagerConfig } from '../models/tag-manager-config.model';
import { referralUrlOrDefault } from '../tokens';


declare global {
    interface Window { dataLayer: any; }
}

@Injectable({ providedIn: 'root' }) // NOTE: Provide in main.ts
export class TagManagerService {

    private window: Window;

    constructor(
        private zone: NgZone,
    ) {
        this.window = window;
        if (!this.window)
            return;


        window.addEventListener('track', (_: CustomEvent<GA4.GA4>) => this.postMessage(_.detail))
    }

    postMessage(ev: GA4.GA4) {
        // if (isDevMode() || !Array.isArray(window.dataLayer))
        //     return;
        this.zone.runOutsideAngular(() => {
            const payload = GA4.payload(ev);


            if (window.dataLayer != null) {
                if (payload && 'ecommerce' in payload) {
                    window.dataLayer.push({ ecommerce: null });
                }
                window.dataLayer.push(payload);
            }
        })
    };


}
